<template>
  <div>

    <div v-html="title" class="subtitle-enquiry"></div>
    
    <v-row>
      <v-col cols="12" md="6">
        <TextField 
          maxlength="40"
          v-model="model.line1" 
          v-if="elsInUse[propertyModelName + 'Line1']"
          @change="_change"
          :label="elsLabel[propertyModelName + 'Line1']"
          :helperText="elsHelperText[propertyModelName + 'Line1']"
          :rules="[rules.text, elsRequired[propertyModelName + 'Line1'] ? rules.required : true]">
        </TextField>
      </v-col>
      <v-col cols="12" md="6">
        <TextField
          maxlength="40"
          v-model="model.line2" 
          v-if="elsInUse[propertyModelName + 'Line2']"
          @change="_change"
          :label="elsLabel[propertyModelName + 'Line2']"
          :helperText="elsHelperText[propertyModelName + 'Line2']"
          :rules="[rules.text, elsRequired[propertyModelName + 'Line2'] ? rules.required : true]">
        </TextField>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <TextField 
          maxlength="40"
          v-model="model.line3" 
          v-if="elsInUse[propertyModelName + 'Line3']"
          @change="_change"
          :label="elsLabel[propertyModelName + 'Line3']"
          :helperText="elsHelperText[propertyModelName + 'Line3']"
          :rules="[rules.text, elsRequired[propertyModelName + 'Line3'] ? rules.required : true]">
        </TextField>
      </v-col>
      <v-col cols="12" md="6">
        <TextField
          maxlength="40"
          v-model="model.line4" 
          v-if="elsInUse[propertyModelName + 'Line4']"
          @change="_change"
          :label="elsLabel[propertyModelName + 'Line4']"
          :helperText="elsHelperText[propertyModelName + 'Line4']"
          :rules="[rules.text, elsRequired[propertyModelName + 'Line4'] ? rules.required : true]">
        </TextField>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <TextField 
          ref="postCode"
          maxlength="40"
          v-model="model.line5" 
          v-if="elsInUse[propertyModelName + 'Line5']"
          @change="_change"
          :label="elsLabel[propertyModelName + 'Line5']"
          :helperText="elsHelperText[propertyModelName + 'Line5']"
          :rules="[adress5Rule, elsRequired[propertyModelName + 'Line5'] ? rules.required : true]">
        </TextField>
      </v-col>
      <v-col cols="12" md="6"></v-col>
    </v-row>

  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import TextField from '@/shared/components/text-field.vue'
  import generic from '@/shared/utils/generic.js';
  import opmGeneric from '../utils/generic.js';
  import constants from '@/shared/constants/generic.js'
  
  export default {
    name: 'PostalAddress',
    components: { 
      TextField, 
    },
    emits: ["input"],
    props: {
      countryID: { type: [Number, String] },
      title: { type: String },
      rules: { type: Object },
      propertyModelName: { type: String },
    },    
    data() {
      return {
        adress5Rule: true,
        model: {
          line1: undefined,
          line2: undefined,
          line3: undefined,
          line4: undefined,
          line5: undefined, // PostCode
        }
      };
    },
    async created() { 
      opmGeneric.setElementsConfig(this, this.elementsConfig); 
    },
    methods: {
      _change() {
        this.$emit("input", generic.toArray(this.model));
      }
    },
    watch: {
      countryID: {
        immediate: true,
        handler(_countryID) {
          if (!this.rules || _countryID === undefined) {
            // When no _countryID is defined it will use the CU country ID
            this.adress5Rule =
              this.$store.state.loanEnquiryConfig.CreditUnionInfo.Country === constants.IE ?
                this.rules.eirCode :
                this.rules.postCode;
            return;
          }

          // Possible Rule to use: eirCode, postCode or text
          // After changing the rule in use, force the validation of the element
          // The 'watch' must finish for the new rule to be applied. The validation will execute immediately (after 0ms)
          const country = this.$store.state.loanEnquiryConfig.ReferenceData.Countries.filter(el => { return el.ID === _countryID; });
          this.adress5Rule = country.length > 0 && country[0].CC === constants.IECountryCode || _countryID === constants.IE ? this.rules.eirCode :
                             country.length > 0 && country[0].CC === constants.UKCountryCode || _countryID === constants.UK ? this.rules.postCode : 
                             this.rules.text;
          
          if (this.$refs.postCode) {
            // children[0] -> input object, children[1] => HelperDialog
            window.setTimeout(function (_el) { _el.validate(); }, 0, this.$refs.postCode.$children[0]);
          }
        }
      }
    },
    computed: {
      ...mapGetters(["elementsConfig"]),
    }
  };
</script>

<style lang="scss" scoped>

</style>